import React, { useEffect, useState } from "react";
import Spacing from "../../Spacing";
import OverViewSection from "../../Section/OverViewSection";
import { useDocumentTitle } from "../../../hooks/customDocumentTitleHook";
import { getPractice, getSecureData,  setSecureData } from "../../../helpers";
import {getGraphDataStatus} from "../../../services/dashboard";
import { fetchFUPatients } from "../../../services/labFollowUp";
import Grid from "../../Grid";
import Card from "../../Card";
import { LockKeyhole } from "lucide-react";
import { Config } from "../../../Config";


export default function AuditDashboard({selectedPracticeChange, fetchChangePracticeData, setFetchChangePracticeData}) {
  var location_id = getPractice("location_id");
  var account_id = getPractice("account_id");
  if(selectedPracticeChange != null && fetchChangePracticeData){
    location_id = selectedPracticeChange?.location_id;
    account_id = selectedPracticeChange?.account_id;
  }

  const [labFUMisiingData, setLabFUMisiingData] = useState(0);
  const [dashboardOverviewDataCounts, setDashboardOverviewDataCounts] = useState({
    high_risk_count: 0,
    preventative_due_count: 0,
    havent_visited: 0,
  });
  const [dashboardLabFULoader, setDashboardLabFULoader] = useState(false);
  const [dashboardGraphLoader, setDashboardGraphLoader] = useState(false);


  const getDashboardOverviewDataCounts = async () => {
    try {
      const response = await getGraphDataStatus({
        location_id: location_id,
        account_id: account_id,
      });
      
      if (response) {
        setDashboardOverviewDataCounts(response?.data);
        await setSecureData("patient_graph_data_status", response?.data);
        await setSecureData("dashboard_fetched_practice_location", location_id);
        setDashboardGraphLoader(false);
      }
    } catch (error) {
      // console.log("🚀 ~ getDashboardOverviewDataCounts ~ error:", error);
    }
  };

  const getDashboardOverviewLavFUData = async () => {
    try {
      const response = await fetchFUPatients({
        location_id: location_id,
        account_id: account_id,
        page: 1,
        per_page: 10000,
      });

      if (response) {
        setLabFUMisiingData(response?.data?.count);
        await setSecureData("patient_lab_fu_status", response.data.count);
        await setSecureData("dashboard_fetched_practice_location", location_id);
        setDashboardLabFULoader(false)
      }
    } catch (error) {
      // console.log("🚀 ~ fetchFUPatients ~ error:", error);
    }
  };


  useEffect(() => {
    const fetchPatientDashboardOverviewStatus = async () => {
          try {
            const _patient_graph_data_status = await getSecureData(
              "patient_graph_data_status"
            );
            const _dashboard_fetched_practice_location = await getSecureData(
              "dashboard_fetched_practice_location"
            );
    
            if (
              !_patient_graph_data_status ||
              _dashboard_fetched_practice_location !== location_id
            ) {
              getDashboardOverviewDataCounts();
              setDashboardGraphLoader(true);
            } else {
              setDashboardOverviewDataCounts(_patient_graph_data_status);
            }
    
            const _patient_lab_fu_status = await getSecureData(
              "patient_lab_fu_status"
            );
            if (
              !_patient_lab_fu_status ||
              _dashboard_fetched_practice_location !== location_id
            ) {
              getDashboardOverviewLavFUData();
              setDashboardLabFULoader(true);
            } else {
              setLabFUMisiingData(_patient_lab_fu_status);
            }
          } catch (error) {
            console.error("Failed to fetch patient graph data status:", error);
          }
        };
        fetchPatientDashboardOverviewStatus();




    const interval = setInterval(() => {
      if (!account_id) {
        clearInterval(interval);     
      }
    }, 500);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(selectedPracticeChange != null && fetchChangePracticeData){
      setDashboardLabFULoader(true);
      setDashboardGraphLoader(true);
      getDashboardOverviewDataCounts();
      getDashboardOverviewLavFUData();
      setFetchChangePracticeData(!fetchChangePracticeData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPracticeChange, fetchChangePracticeData]);

  useDocumentTitle("Dashboard");

  return (
    <>
      <div className="flex items-center justify-between" style={{ justifyContent: 'space-between', gap: '15px 20px' }}>
        <div className="flex items-center">
          <h2 className="docpro_fs_24 docpro_mb_0 mr-2">Overview</h2>
        </div>
      </div>
      <Spacing lg="20" sm="20" />

      <OverViewSection
        dashboardOverviewDataCounts={dashboardOverviewDataCounts}
        selectedPracticeChange={selectedPracticeChange}
        labFUMisiingData={labFUMisiingData}
        dashboardLabFULoader={dashboardLabFULoader}
        dashboardGraphLoader={dashboardGraphLoader}
      />
      <Spacing lg="20" sm="20" />

      <div className="relative">
        <Grid variant={`docpro_grid_gap_20 docpro_grid_col_2`} >
          <Card>
            <div className="docpro_card_1 dashboard_audit_progress">
              <h3 className="docpro_fs_20">Claims submitted</h3>
              <p className="audit_line w-full"></p>
              <p className="audit_line second w-full"></p>
              <p className="audit_line third w-full"></p>
            </div>
          </Card>
          <Card>
            <div className="docpro_card_1 dashboard_audit_progress">
              <h3 className="docpro_fs_20">Payments received</h3>
              <p className="audit_line w-full"></p>
              <p className="audit_line second w-full"></p>
              <p className="audit_line third w-full"></p>
            </div>
          </Card>
        </Grid>
        <Spacing lg="20" sm="20" />

        <Card>
          <div className="dashboard_audit_progress">
            <h3 className="docpro_fs_20">Gaps In Care</h3>
            <Grid variant={`docpro_grid_gap_20 docpro_grid_col_4`} >
              <div className="docpro_border_card">
                <p className="audit_line w-full"></p>
                <p className="audit_line second w-full"></p>
                <p className="audit_line third w-full docpro_mb_0"></p>
              </div>
              <div className="docpro_border_card">
                <p className="audit_line w-full"></p>
                <p className="audit_line second w-full"></p>
                <p className="audit_line third w-full docpro_mb_0"></p>
              </div>
              <div className="docpro_border_card">
                <p className="audit_line w-full"></p>
                <p className="audit_line second w-full"></p>
                <p className="audit_line third w-full docpro_mb_0"></p>
              </div>
              <div className="docpro_border_card">
                <p className="audit_line w-full"></p>
                <p className="audit_line second w-full"></p>
                <p className="audit_line third w-full docpro_mb_0"></p>
              </div>
            </Grid>
          </div>
        </Card>

        <div className="subscribe_lock_box">
          <div className="subscribe_lock">
            <LockKeyhole width={50} height={50} color='#369eff' />
            <Spacing lg="16" sm="16" />
            <p className="docpro_mb_0">
              Subscribe to {Config?._AppName}<br/>
              to access more data and insights.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
